import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/user/add/tenant.user.add.mutation.gql"
import type {
  TenantUserAddMutation,
  TenantUserAddMutationVariables,
} from "@/v2-backoffice-client/tenant/user/add/__types__/tenant.user.add.mutation"

type Options = MutationHookOptions<
  TenantUserAddMutation,
  TenantUserAddMutationVariables
>

export function useTenantUserAddMutation(options?: Options) {
  return useMutation<TenantUserAddMutation, TenantUserAddMutationVariables>(
    mutation,
    options,
  )
}
